// When the ambient Start control (the "Start listening" card, the page-header mic, "Start encounter and listen") may start.
// Its own module so page tests that mock AmbientScribePanel still get the real rule.
import type { AmbientRecordingControl, AmbientSessionStatus } from './AmbientScribePanel';

/** The panel's `restable`: idle, or a finished session (ready, empty, a failure that is not the session's) on an unlocked encounter. */
export function recordingRestable(status: AmbientSessionStatus, failureScope: string | undefined, encounterLocked: boolean): boolean {
  if (status === 'idle') return true;
  if (encounterLocked) return false;
  return status === 'ready' || status === 'empty' || (status === 'failed' && failureScope !== 'session');
}

/** `AmbientRecordingControl.restable`; a control without the field (stories, tests) is at rest only when idle. */
export function recordingControlAtRest(control: Pick<AmbientRecordingControl, 'status' | 'restable'>): boolean {
  return control.restable ?? control.status === 'idle';
}
